import axios, {Method} from 'axios'
import {KEYS} from '../constants/keysStorage'
import { cerrarSesion } from '../actions/general.actions'
import {guardarMensajeDeSesion} from '../utils/sesion.utils'

axios.interceptors.response.use(
  (response) => {
    // * Response satisfactorio
    if (response.data.NewToken)
      localStorage.setItem(KEYS.TOKEN, response.data.NewToken)

    return response
  },
  async function (error) {
    // * response insatisfactorio
    const originalRequest = error.config

    // *Si la respuesta es diferente a 401 o no autorizado retornar el error
    if (
      !error.response ||
      error.response.status !== 401 ||
      originalRequest._retry ||
      originalRequest?.isRefreshing
    ) {
      return Promise.reject(error)
    }

    cerrarSesion()
    guardarMensajeDeSesion(error.response.data.message)
    window.location.replace(`/sesion-caducada`)
  }
)

export function request(method: Method, url: string, data = {}, headers = {}, params = {}) {
  return new Promise(async (resolve, reject) => {
    axios({method, url, data, params, headers})
      .then((response) => resolve(response['data']))
      .catch((error) => {
        if (error.response && error.response.status < 500) return reject(error)

        return reject({
          response: {
            data: {
              message: error?.response?.data?.message ?? 'Servicio no disponible',
              valid: false,
              sesionFinalizada: !localStorage.getItem(KEYS.TOKEN),
            },
          },
        })
      })
  })
}
